import { useAddressSchema } from "@certn/cascadia";
import { t } from "i18next";
import { object, string } from "yup";

export function useDetailsSchema(isBillingProfileChanged: boolean) {
  const addressSchema = useAddressSchema({
    streetAddressFieldName: "address_line_1",
  });

  return object({
    name: string().required().label(t("Group name")),
    applicant_facing_name: string()
      .required()
      .label(t("Applicant facing name")),
    billing_profile: string().required().label(t("Billing profile")),
    address: addressSchema,
    move_uninvoiced_usages: string().when([], {
      is: () => isBillingProfileChanged,
      then: (schema) => schema.required().label(t("Move uninvoiced checks")),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
}
